import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DateTimeDisplay from './DateTimeDisplay';
import DateTimePickerModal from './DateTimePickerModal';

const DateTimePicker = ({
  value = null,
  format = 'MM/DD/YYYY',
  onChange,
  onClose,
  onClick,
  disabled = false,
  timezone = null,
  enableTimezoneAnchor = false,
  timeIntervals,
  allowKeyboardInput,
  customStyles = {},
  ...otherProps
}) => {

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalOpen = () => {
    if (!disabled) {
      if (onClick) onClick({ blur: () => {  setIsModalOpen(false); } }); 
      setIsModalOpen(true);
    }
  };

  const handleModalClose = () => {
    if (onClose) onClose();
    setIsModalOpen(false);
  };

  const handleModalSubmit = (newTimestamp) => {

    /**
     * Step 1: Get the next timezone. If no timezone is provided, use the existing timezone.
     */
    const nextTimezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

    /**
     * We don't have to convert the timestamp to the next timezone here because the DateTimePickerModal will handle it.
     */
    if (onChange) onChange(newTimestamp, nextTimezone);

  };

  const handleClear = () => {
    
    const nextTimezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

   
    if (onChange) onChange(null, nextTimezone);
  
  };

  return (
    <>
      <DateTimeDisplay
        value={value}
        format={format}
        timezone={timezone}
        onClick={handleModalOpen}
        disabled={disabled}
        customStyles={customStyles}
        {...otherProps}
      />
      <DateTimePickerModal
        isOpen={isModalOpen}
        value={value}
        format={format}
        onSubmit={handleModalSubmit}
        onClose={handleModalClose}
        onClear={handleClear}
        timeIntervals={timeIntervals}
        timezone={timezone}
      />
    </>
  );
};

DateTimePicker.propTypes = {
  value: PropTypes.number,
  format: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  timezone: PropTypes.string,
  enableTimezoneAnchor: PropTypes.bool,
  timeIntervals: PropTypes.number,
  allowKeyboardInput: PropTypes.bool,
  customStyles: PropTypes.shape({
    fontSize: PropTypes.number,
    fontColor: PropTypes.string,
    fontStyle: PropTypes.string,
    fontWeight: PropTypes.string,
    textAlign: PropTypes.string,
    textTransform: PropTypes.string,
    textDecoration: PropTypes.string,
    textOverflow: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.number,
    backgroundColor: PropTypes.string,
    padding: PropTypes.number,
    primaryColor: PropTypes.string
  })
};

export default DateTimePicker;
